export const getCateringLabel = (key: string) => {
    const labels: Record<string, string> = {
      dinnerFriday: "Abendessen Freitag",
      dinnerFridayVeg: "Abendessen Freitag (Vegetarisch)",
      breakfastSaturday: "Frühstück Samstag",
      breakfastSunday: "Frühstück Sonntag"
    };
    return labels[key] || key; // Falls ein neuer Key hinzugefügt wird, den Original-Key zurückgeben
  };

export const getOvernightLabel = (key: string) => {
    const labels: Record<string, string> = {
      fridayToSaturday: "Übernachtung Freitag auf Samstag",
      saturdayToSunday: "Übernachtung Samstag auf Sonntag"
    };
    return labels[key] || key;
  };
